module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"11","viewBox":"0 0 15 11"},"content":"<g fill=\"none\">     <rect width=\"15\" height=\"11\" fill=\"#0084FF\" rx=\"2\"/>     <rect width=\"11\" height=\"1\" x=\"2\" y=\"7\" fill=\"#FFF\" rx=\".5\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-card.svg
// module id = 1283
// module chunks = 0